import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { useTheme } from 'styled-components';

type ArrowRightAltProps = IconComponentBaseProps;

export const ArrowRightAlt = ({ width = 24, height = 24, fill, className }: ArrowRightAltProps) => {
  const theme = useTheme();
  const id = useId();
  const iconFill = fill || theme.mantineColors.gray[7];

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={id} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill={iconFill} />
      </mask>
      <g mask={`url(#${id})`}>
        <path
          d="M17.615 12.75H5.56727C5.34159 12.75 5.15266 12.6781 5.00049 12.5345C4.84814 12.391 4.77197 12.2128 4.77197 12C4.77197 11.7871 4.84814 11.609 5.00049 11.4655C5.15266 11.3218 5.34159 11.25 5.56727 11.25H17.615L14.1239 7.95771C13.9663 7.80887 13.8884 7.63479 13.8904 7.43546C13.8925 7.23612 13.9703 7.05888 14.1239 6.90371C14.2885 6.74871 14.4774 6.66862 14.6907 6.66346C14.9042 6.65829 15.0932 6.73329 15.2578 6.88846L20.007 11.3672C20.1064 11.4609 20.1764 11.5596 20.217 11.6635C20.2578 11.7673 20.2782 11.8795 20.2782 12C20.2782 12.1205 20.2578 12.2326 20.217 12.3365C20.1764 12.4403 20.1064 12.539 20.007 12.6327L15.2578 17.1115C15.0999 17.2601 14.9127 17.3335 14.696 17.3317C14.4792 17.3297 14.2885 17.2512 14.1239 17.0962C13.9703 16.941 13.8908 16.7654 13.8853 16.5692C13.8799 16.373 13.9594 16.1974 14.1239 16.0422L17.615 12.75Z"
          fill={iconFill}
        />
      </g>
    </svg>
  );
};
